import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_AD_UNITS_PRODUCT_ENABLED: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateAdUnitsProductEnabled($input: UpdateAdUnitsProductEnabledInput!) {
    updateAdUnitsProductEnabled(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
